@import "@/ui/variables.css";

.labelRoot {
  font-size: 0.9rem;
  display: block;
  text-shadow: var(--inset-text-shadow);
}
